import { connect } from "react-redux";

import { isNotNullOrUndefined } from "../../../../../Common/TypingUtils";
import { FullFormState } from "../../../Engine/Core/Store/FullFormState";
import { ViewModelSelect } from "../../../Helpers/StateAccessors/ViewModelSelect";
import { withViewModelSelect } from "../../withViewModelSelect";
import { withEvaluators, type EvaluableProp, type EvaluatorsInjectableProps } from "../../withEvaluators";
import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";
import { withResolvePaths } from "../../withResolvePaths";

import { DropdownButton } from "./DropdownButton";

interface DropdownButtonContainerProps extends EvaluatorsInjectableProps {
    viewModelSelect: ViewModelSelect;
    bindingPath?: AbsoluteModelPath;
    disabled2?: EvaluableProp<boolean>;
}

const mapStateToProps = (state: FullFormState, ownProps: DropdownButtonContainerProps) => {
    const { disabled2, processEvaluableProp } = ownProps;

    if (isNotNullOrUndefined(disabled2)) {
        return {
            disabled: processEvaluableProp(state, disabled2),
        };
    }

    return {};
};

export const DropdownButtonContainer = withResolvePaths(
    withViewModelSelect(withEvaluators(connect(mapStateToProps)(DropdownButton)))
);
